import {useEffect, useRef} from 'react';

export const useEffectFirstSkip = (effect: any, dependecies: any) => {
  let skipFirstEffect = useRef(false);

  useEffect(() => {
    if (skipFirstEffect.current) {
      return effect();
    } else {
      skipFirstEffect.current = true;
    }
  }, dependecies);
};
